module Eseebase {

    export class ForgeJobViewModel {
        objectId: string;
        fileId: string;
        fileName: string;
        isCompleted: boolean;
        IsFailed: boolean;
        Progress: string;
    }

}